import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MailIcon, PlusIcon } from 'lucide-react';
import { FAQS, SUPPORT_EMAIL } from '../../data/woodworking';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <section id="faq" className="bg-ivory py-14 text-ink sm:py-20" aria-labelledby="faq-title" data-id="element-214" data-mp="ur2m0uol16p4">
      <div className="mx-auto grid w-full max-w-6xl gap-6 px-5 sm:px-8 lg:grid-cols-12 lg:gap-14" data-id="element-215" data-mp="718787kpd828">
        <div className="lg:col-span-4" data-id="element-216" data-mp="22dhsms8cl95">
          <p className="label-tech flex items-center gap-3 text-brass" data-id="element-217" data-mp="23f5bqqfn07r">
            <span className="h-px w-6 shrink-0 bg-current" aria-hidden data-id="element-218" data-mp="gzxkfn1nm4c5" />
            FAQ
          </p>
          <h2 id="faq-title" className="mt-4 text-balance font-brand text-[1.8rem] font-bold leading-[1.18] tracking-[-0.01em] text-ink sm:text-[2.3rem]" data-id="element-219" data-mp="bzrviemrqvxr">
            Questions before you start?
          </h2>
          <p className="mt-4 max-w-sm text-[0.95rem] leading-relaxed text-stone" data-id="element-220" data-mp="1nf6v7q6d41wk">
            Every buyer gets personal email support from our team.
          </p>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="mt-2 inline-flex min-h-[44px] items-center gap-2 text-[0.92rem] font-semibold text-forest underline decoration-brass/40 underline-offset-4 transition-colors duration-150 ease-out hover:decoration-brass focus:outline-none focus-visible:ring-2 focus-visible:ring-forest/40" data-id="element-221" data-mp="ms0woiu3bkz3">
            <MailIcon className="h-4 w-4 shrink-0 text-brass" aria-hidden data-id="element-222" data-mp="42c9xd0e7aut" />
            <span className="break-all" data-id="element-223" data-mp="4086ew6eodv2">{SUPPORT_EMAIL}</span>
          </a>
        </div>

        <ul className="divide-y divide-ivory-line border-y border-ivory-line lg:col-span-8" data-id="element-224" data-mp="82mnpbuff5k8">
          {FAQS.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.question} data-id="element-225" data-mp="3chvxbvedtz1y" data-mpi={index}>
                <h3 data-id="element-226" data-mp="3gjhh80pc3dln">
                  <button type="button" id={`faq-trigger-${index}`} onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex min-h-[64px] w-full items-center justify-between gap-4 py-4 text-left focus:outline-none focus-visible:ring-4 focus-visible:ring-forest/30" data-id="element-227" data-mp="3gixxqfk1ch5i">
                    <span className="text-[1.02rem] font-semibold leading-snug text-ink sm:text-[1.08rem]" data-id="element-228" data-mp="4qd9rd5d9nls">
                      {faq.question}
                    </span>
                    <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ease-out ${isOpen ? 'border-forest bg-forest text-ivory' : 'border-ink/20 text-ink'}`} aria-hidden data-id="element-229" data-mp="3vysmideiorny">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-230" data-mp="1l5eliut1y3rt" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-231" data-mp="1xl5w5dxojiog">
                  {isOpen && <motion.div id={`faq-panel-${index}`} role="region" aria-labelledby={`faq-trigger-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-232" data-mp="1irjaasnd2f26">
                      <p className="max-w-2xl pb-5 pr-12 text-[0.98rem] leading-relaxed text-stone" data-id="element-233" data-mp="26m46edypomfh">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}